import { render, staticRenderFns } from "./holidays.vue?vue&type=template&id=b126ec50&scoped=true"
import script from "./holidays.vue?vue&type=script&lang=js"
export * from "./holidays.vue?vue&type=script&lang=js"
import style0 from "./holidays.vue?vue&type=style&index=0&id=b126ec50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b126ec50",
  null
  
)

export default component.exports